<template>
  <span class="c-color" :class="theme && `c-color-${theme}`" :style="rootStyle">
    <slot/>
  </span>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import { HexColor } from '../models/common';

  export type Theme = 'neutral'
    | 'neutral-dark'
    | 'info'
    | 'info-dark'
    | 'success'
    | 'warning'
    | 'warning-dark'
    | 'danger'
    | 'contrast';

  const props = defineProps<{
    theme?: Theme;
    color?: HexColor
  }>();

  const rootStyle = computed(() => {
    if (props.color) {
      return { color: `#${props.color}` };
    }
  });
</script>

<style lang="scss">
  .c-color {
    &-neutral {
      color: $neutral-400;
    }

    &-neutral-dark {
      color: $neutral-700;
    }

    &-info {
      color: $info;
    }

    &-info-dark {
      color: $info-800;
    }

    &-success {
      color: $success;
    }

    &-warning {
      color: $warning;
    }

    &-warning-dark {
      color: $warning-800;
    }

    &-danger {
      color: $danger;
    }

    &-contrast {
      color: $neutral-1000;
    }
  }
</style>
